<template>
    <AppLayout v-bind="customerSharedData.getAppLayoutProps(pageMeta)">
        <div class="mt-4">
            <CustomerMeetingCard
                :meetingData="localMeetingData"
                :attendanceData="
                    localMeetingData.getSingleExistingAttendanceData()
                "
                :reservationData="
                    localMeetingData.getSingleExistingReservationData()
                "
            />
        </div>
    </AppLayout>
</template>

<script setup lang="ts">
    import AppLayout from '@/Shared/Layout/Customer/Topbar/AppLayout.vue'
    import { type PageMeta } from '@/Shared/AutoGenerated/Main'
    import CustomerSharedData from '@/Shared/Entity/CustomerSharedData'
    import MeetingData from '@/App/Booking/Meeting/Entity/MeetingData'
    import CustomerMeetingCard from '@/Customer/Meeting/Component/CustomerMeetingCard.vue'

    interface ShowMeetingProps {
        pageMeta: PageMeta
        customerSharedDataData: any
        meetingData: any
    }

    const props = defineProps<ShowMeetingProps>()
    const customerSharedData = CustomerSharedData.hydrate(
        props.customerSharedDataData,
    )
    const localMeetingData = MeetingData.hydrateSingle(props.meetingData)
</script>
